export function limit(func: Function, duration: number) {
  let timeoutHandle: any = null;
  return function (...args: any) {
    if (timeoutHandle) {
      clearTimeout(timeoutHandle);
    }

    timeoutHandle = setTimeout(() => {
      // @ts-ignore
      func.apply(this, args);
    }, duration);
  }
}

type Listener = (window: Window, uiEvent: UIEvent, width: number) => void;

export class WindowResizeHelper {

  private static msInstance: WindowResizeHelper | null = null;
  private mListeners: Listener[] = [];
  private lastWidth: number;

  constructor() {
    this.onResize = this.onResize.bind(this);
    window.addEventListener('resize', this.onResize as any);
  }
  public static getInstance(): WindowResizeHelper {
    if (!WindowResizeHelper.msInstance) {
      WindowResizeHelper.msInstance = new WindowResizeHelper();
    }
    return WindowResizeHelper.msInstance;
  }

  public addListener(listener: Listener) {
    this.mListeners.push(listener);
  }
  public removeListener(listener: Listener) {
    const pos = this.mListeners.indexOf(listener);
    if (pos > -1) {
      this.mListeners.splice(pos, 1);
    }
  }

  private callListeners = limit((win: Window, uiEvent: UIEvent) => {
    this.mListeners.forEach((listener) => listener(win, uiEvent, this.lastWidth))
    this.lastWidth = window.innerWidth;
  }, 200);

  private onResize(e: Window, uiEvent: UIEvent) {
    this.callListeners(e, uiEvent)
  }

}
